<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <div v-if="success" class="card">
          <div class="card-body green">You successfully edited this promotion!</div>
        </div>
      </b-col>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>Send Email</strong>
          </div>
          <b-form @submit.prevent="editPromotion">
            <b-row>
              <b-col sm="12">
                <b-form-group>
                  <label for="promotion_name">Name</label>
                  <b-form-input
                    type="text"
                    v-validate="'required'"
                    v-model="promotion.promotion_name"
                    name="promotion_name"
                    placeholder="Enter your promotion name"
                    :class="{'has-error': errors.has('promotion_name')}"
                  >
                  </b-form-input>
                  <span class="red">{{ errors.first('promotion_name') }}</span>
                </b-form-group>
              </b-col>
            </b-row>
          <b-form-group
            label="Select Device"
            label-for="basicSelect">
            <b-form-select
              v-model="promotion.device_id"
              :plain="true"
              :options="devices"
              value="Please select">
            </b-form-select>
          </b-form-group>
          <b-form-group
            label="Frequency">
            <b-form-select v-model="promotion.frequency"
              :plain="true"
              :options="frequencyList"
              value="Please select">
            </b-form-select>
          </b-form-group>
          <b-form-group>
            <label>Email Message</label>
            <quill-editor
              v-model="promotion.message"
              ref="myQuillEditor"
              :options="editorOption"
              @blur="onEditorBlur($event)"
              @focus="onEditorFocus($event)"
              @ready="onEditorReady($event)">
            </quill-editor>
          </b-form-group>
          <b-form-group>
            <b-form-checkbox id="checkbox1" v-model="promotion.active">
              Set as Active
            </b-form-checkbox>
          </b-form-group>
          <div class="form-actions">
            <b-button type="submit" variant="primary">Submit</b-button>
          </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'

export default {
  name: 'RegisterDevice',
  components: {
    quillEditor
  },
  data () {
    return {
      content: '',
      editorOption: {
        // some quill options
        theme: 'snow'
      },
      devices: [],
      frequencyList: [
        'Once',
        'Once per Hour',
        'Once per Day',
        'Once per Week'
      ],
      promotion: {},
      success: false
    }
  },
  computed: {
    editor () {
      return this.$refs.myQuillEditor.quill
    },
    contentCode () {
      return this.content
    }
  },
  methods: {
    /**
     * Sends a put request to backend API to update promotion details.
     */
    editPromotion () {
      let self = this
      let promotion = this.promotion

      this.$validator.validateAll().then((result) => {
        if (result) {
          axios.put(`${process.env.VUE_APP_API_URL}api/promotions/${this.$route.params.id}`, {
            device_id: promotion.device_id,
            frequency: promotion.frequency,
            message: promotion.message,
            promotion_name: promotion.promotion_name,
            criteria: promotion.criteria
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'x-access-token': localStorage.getItem('user-token')
            }
          })
            .then(function (response) {
              self.success = true
              window.scrollTo(0, 0)

              self.setActive()
            })
            .catch(function (error) {
              console.log(error)
            })
        }
      }).catch(() => {
        console.log(this.errors.all())
      })
    },
    /**
     * Gets list of all devices from backend API in order to populate the device select dropdown.
     */
    getDevices () {
      let self = this

      axios.get(`${process.env.VUE_APP_API_URL}api/devices/`, {
        headers: {
          'x-access-token': localStorage.getItem('user-token')
        }
      })
        .then(function (response) {
          let data = response.data.data
          let devices = []

          for (let i = 0; i < data.length; i++) {
            devices.push({
              value: data[i]['device_id'],
              text: data[i]['company_name'] + ' - ' + data[i]['device_name']
            })
          }

          self.devices = devices
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    /**
     * Gets promotion details from backend API by id.
     */
    getPromotion () {
      let self = this

      axios.get(`${process.env.VUE_APP_API_URL}api/promotions/${this.$route.params.id}`, {
        headers: {
          'x-access-token': localStorage.getItem('user-token')
        }
      })
        .then(function (response) {
          self.promotion = response.data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    onEditorBlur (quill) {
      console.log('editor blur!', quill)
    },
    onEditorFocus (quill) {
      console.log('editor focus!', quill)
    },
    onEditorReady (quill) {
      console.log('editor ready!', quill)
    },
    onEditorChange ({ quill, html, text }) {
      console.log('editor change!', quill, html, text)
      this.content = html
    },
    /**
     * Toggles the active state in the backend API by whether the 'Set As Active' checkbox was checked or not.
     */
    setActive () {
      axios.put(`${process.env.VUE_APP_API_URL}api/promotions/set_active`, {
        device_id: this.promotion.device_id,
        promotion_id: this.promotion.promotion_id,
        active: this.promotion.active
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': localStorage.getItem('user-token')
        }
      })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  mounted () {
    this.getDevices()
    this.getPromotion()
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.quill-code {
    border: none;
    height: auto;
    > code {
      width: 100%;
      margin: 0;
      padding: 1rem;
      border: 1px solid #ccc;
      border-top: none;
      border-radius: 0;
      height: 10rem;
      overflow-y: auto;
      resize: vertical;
    }
  }
</style>
